import { client } from "utils/axios"
import * as yup from "yup";
import { showMessage } from "store/modules/Message";

export async function deleteCategoriesType(categoryId) {
    await client.delete(`typeCategory/${categoryId}`);
};
export async function getAllCategoriesType() {
    const { data } = await client.get("/typeCategory");
    return data;
}

export const validationSchemaCategoriesType = yup.object({
    name: yup
        .string("Ingresa nombre de CategoriesType")
        .required("Campo Requerido"),
    code: yup
        .string("Ingresa Codigo")
        .required("Campo Requerido"),
});
export const createCategoriesType = async (categoryType, dispatch) => {
    try {
        await client.post("typeCategory", categoryType);
        dispatch(
            showMessage({
                message: "Tipo de categoría agregado con éxito",
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
            })
        );
        return true;
    } catch (error) {
        dispatch(
            showMessage({
                message: error?.response?.data?.message || "Ocurrió un error al agregar el tipo de categoría",
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
            })
        );
        return false;
    }
};

export const modifyCategoriesType = async (categoryType, dispatch) => {
    try {
        await client.put("typeCategory", categoryType);
        dispatch(
            showMessage({
                message: `Tipo de categoría "${categoryType.name}" modificado con éxito`,
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );
        return true;
    } catch (error) {
        dispatch(
            showMessage({
                message: error?.response?.data?.message || `Ocurrió un error al modificar el tipo de categoría "${categoryType.name}"`,
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );
        return false;
    }
};
